module.exports = __webpack_public_path__ + "static/img/16.30e7881b.png";